export default {
  user: {},
  middle: true,
  version: 'h5',
}
